export default {
  BANNER: 'BANNER',
  ONE_LINE: 'ONE_LINE',
  TWO_LINE: 'TWO_LINE',
  EPISODES: 'EPISODES',
  COLLECTION: 'COLLECTION',
  CUSTOM: 'CUSTOM',
  LOGO: 'LOGO',
  LIVE: 'LIVE',
  HERO: 'HERO',
  HERO_MULTIPLE: 'HERO_MULTIPLE',
  HERO_SLIDER: 'HERO_SLIDER',
  HERO_SIMPLE: 'HERO_SIMPLE',
  BILLBOARD: 'BILLBOARD',
  EPG_FULL: 'EPG_FULL',
  EPG_FILTER: 'EPG_FILTER',
  EPG_SIMPLE: 'EPG_SIMPLE',
  DEFAULT: 'DEFAULT',
  SERIES: 'SERIES',
  LEADERBOARD: 'LEADERBOARD',
  OUTSTREAM: 'OUTSTREAM',
};
